export default {
      id: "layer-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#layer",
      toString: function () {
        return this.url;
      }
    }